module.exports = __webpack_public_path__ + "img/sample-receipt.42399d4e.png";